import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { TopicSpecialistRow } from '../topic-specialists-view.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService): GridSetup<TopicSpecialistRow> {

	return {
		rowName: { singular: 'Topic Specialist', plural: 'Topic Specialists' },
		getRowKey: row => '' + row.accTopicSpecialistId,
		stateKey: 'accelerator-topic-specialists-grid',
		actions: getActions(),
		buttons: [],
		columns: getColumns(util),
	}
}
